import { createSlice } from '../utils/@reduxjs/toolkit';
import { ContainerState } from './types';

export const initialState: ContainerState = {
    selectedLanguage: 'en'
};

const mainMenuSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setLanguage(state: any, { payload }: any) {
            return {
                ...state,
                selectedLanguage: payload
            }
        },
    },
});

export const { actions, reducer, name: sliceKey } = mainMenuSlice;
